import React from 'react';
import { Link } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import EDSFooter from '../components/EDSFooter';

const Potwierdz_rejestracje_konta = () => {
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content responsive-padding">
                <div className="margin-top-32">
                    <a href="">
                        <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                    </a>
                </div>
                <main className="margin-top-64">
                    <div className="texts text-box">
                        <h2 className="h2">Potwierdź rejestrację konta.</h2>
                        <p className="margin-top-16">Profil został utworzony.</p>
                        <p>
                            Na podany adres e-mail wysłaliśmy wiadomość z&nbsp;linkiem aktywacyjnym.
                        </p>
                        <p>
                            Potwierdź rejestrację konta klikając w&nbsp;link aktywacyjny. Postępuj
                            zgodnie z&nbsp;instrukcjami zawartymi w&nbsp;mailu.
                        </p>
                        <p className="margin-top-16">Nie dostałeś/łaś naszej wiadomości?</p>
                        <p>
                            Sprawdź foldery <span className="fw-700">spamu i poczty masowej</span>.
                        </p>
                        <div className="margin-top-64">
                            <h2 className="h2 margin-top-16">INFOLINIA</h2>
                            <p className="margin-top-8">czynna od poniedziałku do piątku</p>
                            <p>w godzinach 9:00 - 17:00</p>
                            <p className="margin-top-16">tel.: 601 20 20 20</p>
                            <p>e-mail: studio@egurrola.pl</p>
                        </div>
                        <Link to="/">
                            <a
                                href=""
                                className="btn-secondary-responsive btn-secondary-responsive--medium margin-top-64  margin-bottom-32"
                            >
                                Wróć do strony głównej
                            </a>
                        </Link>
                    </div>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Potwierdz_rejestracje_konta;
